import type { BillingEnterpriseSubscriptionPriceKey } from '../types/billing';
import { ApiError } from '../types/errors';
import { isBillingSubscriptionPriceKey, getBillingSubscriptionPlan } from './billingSubscriptionPlans';
import { clearBillingCheckoutContext } from './billingCheckoutContext';

export function isBusinessSubscriptionPriceKey(value: unknown): value is BillingEnterpriseSubscriptionPriceKey {
  return isBillingSubscriptionPriceKey(value) && getBillingSubscriptionPlan({ priceKey: value }) === 'enterprise';
}

export function subscriptionChangeErrorCode(error: unknown): string | undefined {
  if (!(error instanceof ApiError) || error.statusCode !== 409 || !error.details || typeof error.details !== 'object') return undefined;
  const code = (error.details as Record<string, unknown>).code;
  return typeof code === 'string' ? code : undefined;
}

export function subscriptionChangeErrorKey(error: unknown): string {
  const code = subscriptionChangeErrorCode(error);
  return code === 'ALREADY_BUSINESS' ? 'billing.subscriptionChange.alreadyBusiness'
    : code === 'SUBSCRIPTION_CHANGE_UNSUPPORTED' ? 'billing.subscriptionChange.unsupported'
    : 'billing.subscriptionChange.error';
}

export function subscriptionChangeReturnUrl(rawUrl = window.location.href): string {
  const url = new URL(rawUrl);
  clearBillingCheckoutContext(url);
  url.searchParams.delete('billing_session_id');
  url.searchParams.set('billing', 'subscription_change');
  return url.toString();
}

export function hasSubscriptionChangeReturn(rawUrl = window.location.href): boolean {
  return new URL(rawUrl).searchParams.get('billing') === 'subscription_change';
}
